module.exports = __webpack_public_path__ + "media/images/flags/32/Samoa-a45dc8a0841249e675d6a108ed4d9b60.png";